import { render } from "./ElNewsNote.vue?vue&type=template&id=ccdd6a8c&scoped=true&lang=html"
import script from "./ElNewsNote.vue?vue&type=script&lang=js"
export * from "./ElNewsNote.vue?vue&type=script&lang=js"

import "./ElNewsNote.vue?vue&type=style&index=0&id=ccdd6a8c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdd6a8c"]])

export default __exports__